import { useCallback, useEffect, useRef, useMemo, useState } from 'react';
import chunk from 'lodash/chunk';
// import { CATEGORY_KEY, POPULAR_KEY, RECOMMENDED_KEY } from '../constant';
import { CATEGORY_KEY, POPULAR_KEY } from '../constant';
import useSearch from '../../../../../hooks/useSearch';
import { isDefined } from '../../../../../utils/helpers';
import { usePaymentFlowContext } from '../../../../FlowDetailsPage/paymentFlowContext';

const DEFAULT_MAX = 20;
const OBSERVER_MAX = 10;

const useInfiniteScroll = () => {
  const {
    templates,
    popularTemplates,
    paymentProcessingBaseTemplate,
    // recommendedTemplates,
    templatesLoading,
  } = usePaymentFlowContext();
  const [hasMore, setHasMore] = useState(false);
  const [templateList, setTemplateList] = useState([]);

  const [searchParams] = useSearch();
  // Apply search filter
  const filteredTemplates = useMemo(() => {
    // if (searchParams?.[CATEGORY_KEY] === RECOMMENDED_KEY) {
    //   return recommendedTemplates;
    // }
    if (searchParams?.[CATEGORY_KEY] === POPULAR_KEY) {
      return popularTemplates;
    }
    return isDefined(searchParams?.[CATEGORY_KEY])
      ? templates.filter((template) => {
          const categories = template?.categories?.map((cat) => cat?.toLowerCase());
          return categories?.includes(searchParams?.[CATEGORY_KEY]);
        })
      : templates;
  }, [searchParams, templates, popularTemplates]);

  // set filteredTemplates to templateList
  useEffect(() => {
    const chunks = chunk(filteredTemplates, DEFAULT_MAX);
    const currentlyHasMore = chunks?.length > 1;

    setHasMore(currentlyHasMore);
    setTemplateList(chunks[0] || []);
  }, [filteredTemplates]);

  const loaderRef = useRef(null);

  const loaderRefFn = useCallback(
    (node) => {
      if (loaderRef.current) loaderRef?.current?.disconnect?.();
      loaderRef.current = new IntersectionObserver((entries) => {
        // Update templateList and check if there are more templates left
        if (entries?.[0]?.isIntersecting && hasMore) {
          const newMax = templateList?.length + OBSERVER_MAX;
          const newChunks = chunk(filteredTemplates, newMax);
          const newHasMore = newChunks?.length > 1;

          setHasMore(newHasMore);
          setTemplateList(newChunks[0]);
        }
      });

      if (node) loaderRef?.current?.observe?.(node);
    },
    [hasMore, filteredTemplates, templateList]
  );

  return { loaderRefFn, loading: templatesLoading, templateList, paymentProcessingBaseTemplate, templates };
};

export { useInfiniteScroll };
